import { defineComponent, nextTick, ref } from 'vue';
import classNames from '../../_util/classNames';
import Input from '../Input';
const DEFAULT_MASK = '•';
export default defineComponent({
    name: 'AOTPInput',
    inheritAttrs: false,
    props: {
        index: { type: Number, required: true },
        value: { type: String, default: '' },
        disabled: Boolean,
        size: String,
        status: String,
        mask: { type: [Boolean, String] },
        type: String,
        inputMode: String,
        autoComplete: String,
        autofocus: Boolean,
        class: String,
        bordered: { type: Boolean, default: true },
    },
    emits: ['change', 'activeChange', 'focus'],
    setup(props, { emit, expose }) {
        const inputRef = ref();
        const syncSelection = () => {
            nextTick(() => {
                var _a, _b;
                (_b = (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.select) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
        };
        expose({
            focus: () => { var _a, _b; return (_b = (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a); },
            blur: () => { var _a, _b; return (_b = (_a = inputRef.value) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 ? void 0 : _b.call(_a); },
            input: inputRef,
        });
        return () => {
            var _a;
            const prefixCls = 'ant-otp';
            const maskValue = typeof props.mask === 'string' ? props.mask : DEFAULT_MASK;
            const showMask = !!props.mask && props.value !== '' && props.value !== undefined;
            return (<span class={`${prefixCls}-input-wrapper`} role="presentation">
          {showMask && (<span class={`${prefixCls}-mask-icon`} aria-hidden="true">
              {maskValue}
            </span>)}
          <Input ref={inputRef} aria-label={`OTP Input ${props.index + 1}`} size={props.size} status={props.status} disabled={props.disabled} bordered={props.bordered} maxlength={1} value={props.value} autofocus={props.autofocus} autocomplete={props.autoComplete} type={(_a = props.type) !== null && _a !== void 0 ? _a : (props.mask ? 'password' : 'text')} class={classNames(props.class, `${prefixCls}-input`, {
                    [`${prefixCls}-mask-input`]: !!props.mask,
                })} {...(props.inputMode ? { inputmode: props.inputMode } : {})} onFocus={(e) => {
                    emit('focus', e);
                    syncSelection();
                }} onMousedown={syncSelection} onMouseup={syncSelection} onKeydown={(e) => {
                    const { key, ctrlKey, metaKey } = e;
                    if (key === 'ArrowLeft') {
                        emit('activeChange', props.index - 1);
                    }
                    else if (key === 'ArrowRight') {
                        emit('activeChange', props.index + 1);
                    }
                    else if (key === 'z' && (ctrlKey || metaKey)) {
                        e.preventDefault();
                    }
                    else if (key === 'Backspace' && !props.value) {
                        emit('activeChange', props.index - 1);
                    }
                    syncSelection();
                }} onChange={(e) => {
                    emit('change', props.index, e.target.value);
                }}/>
        </span>);
        };
    },
});
